module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C71"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("Preface")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "C72"
  }, [_c('em', [_vm._v("Even Detroit")])]), _vm._v(" "), _c('p', {
    staticClass: "C85"
  }, [_vm._v("DAN GILBERT is not just a cockeyed optimist. He’s a cockeyed optimist with a mission and a wide-open checkbook.")]), _vm._v(" "), _c('p', {
    staticClass: "C86"
  }, [_vm._v("Because he’s trying to rescue his hometown of Detroit—America’s poorest, most crime-ridden, depopulated big city—press accounts of Gilbert’s efforts thus far have been admiring but skeptical. Adjectives such as “altruistic” or “quixotic” keep popping up in these stories. Between the lines, reporters seem to be saying, “This guy might be a hero, or he might be nuts. But at least he’s risking his own dough.”")]), _vm._v(" "), _c('p', {
    staticClass: "C86"
  }, [_vm._v("Lots of it. Since 2010, Gilbert, the founder of mortgage giant Quicken Loans, has moved ten thousand of his employees from the suburbs to downtown Detroit, invested over $1 billion to buy and rehab three million square feet of city property, bankrolled dozens of tiny startups, and coaxed famous-brand retailers into long-vacant buildings with dirt-cheap rents. His “Opportunity Detroit” program may be the most ambitious privately financed urban renewal effort in U.S. history.")]), _vm._v(" "), _c('p', {
    staticClass: "C86"
  }, [_vm._v("Gilbert was undaunted even when the city declared itself bankrupt in July 2013, with $18 billion in debt—over $25,000 for every man, woman, and child yet to pack up and leave—and little with which to pay it. “We are all in,” he declared, arguing that bankruptcy, though painful for many, would enable the city to “reinvent itself” and emerge stronger, much as General Motors and Chrysler did in the aftermath of the Great Recession.")]), _vm._v(" "), _c('p', {
    staticClass: "C86"
  }, [_vm._v("Is this a savvy bet, or the pipedream of a hometown fan destined to lose his shirt?")]), _vm._v(" "), _c('p', {
    staticClass: "C86"
  }, [_vm._v("This question is central to the business of this book. Like Gilbert, I’m optimistic about the fate of American cities. I believe all can become boom towns; none are obsolete or beyond hope. But let’s not be naive: to thrive they must get right some very basic public policies and avoid others that, as they did in Detroit, inevitably lead to disaster.")])]), _c('p', {
    staticClass: "C86"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("For decades, sophisticated and expensive urban revitalization pro")]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("grams have proven to be disappointing. Governments have spent billions of taxpayer dollars on convention centers, municipal complexes, public housing, and stadiums; they have subsidized private investment in hotels, office towers, and entertainment districts. The hope has been that upgrading a city’s built environment—its inventory of structures and other physical capital—would halt the flight of employers and residents to the suburbs. All too often these efforts have utterly failed to pull troubled municipalities out of their downward spirals. Detroit is Exhibit A, but there are many others.")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('p', {
    staticClass: "C86"
  }, [_vm._v("More recently, as the U.S. economy has become more knowledge-based and service-oriented, policymakers have focused on increasing cities’ stocks of human capital. They have courted tech companies and channeled funding into facilities and programs that might appeal to “creatives”—the entrepreneurs, intellectuals, professionals, and artists thought to be catalysts of urban economic revival. Again, results are mixed at best.")]), _vm._v(" "), _c('p', {
    staticClass: "C86"
  }, [_vm._v("The theories on which these strategies are based are not wrong—but they are incomplete. Urban renewal investments often bear little fruit because planners frequently ignore the underlying conditions necessary for them to work as intended. The devil is not in the details, but in a crucial but overlooked fundamental: property rights. In a nutshell, too many cities are in trouble because they’ve failed to protect the value of their residents’ private property and to efficiently manage the property that their citizens own in common with each other.")]), _vm._v(" "), _c('p', {
    staticClass: "C86"
  }, [_vm._v("Cities are not just dense concentrations of people but vast reservoirs of productive capital—from the buildings residents inhabit and the infrastructure that facilitates their work and play to the intangible, such as their skills or the networks of friends and associates they rely on to enrich their lives. And the record is clear: cities grow and prosper when they encourage the formation of capital in its many forms by securing the returns that flow from it. That is, cities thrive when their residents’ property rights are well specified and enforced, and they die a little each day when these rights are attenuated.")])]), _c('p', {
    staticClass: "C86"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("It turns out that the nature and strength of the rights that attach to a particular place have enormous influence on people’s behavior and overall social welfare. We don’t like it when the value of our home falls because ")]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("a property tax hike is unaccompanied by added municipal services, for example. We grumble when we can’t take our kids to the park because a crack dealer is using it as his office, or when the potholes on our thoroughfares seem never to be filled.")])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('p', {
    staticClass: "C86"
  }, [_vm._v("When local policies damage our property rights—when they impair our claims to the financial benefits or services generated by our property—we tend to migrate to places where those rights are better protected. And we take our human, financial, physical, and social capital with us. This is often how a city starts to spiral downward. As you’ll see, Detroit is, again, a prime example. Dan Gilbert is likely to find that unless the city pays close attention to the proper specification and efficient enforcement of property rights, even his laudable efforts will end badly.")])]), _c('p', {
    staticClass: "C86"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("In this book, I illustrate the power and potential of this property rights approach to urban health and offer “how to” guidance for its implementation. An ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/06_1__What#page_1"
    }
  }, [_vm._v("introductory chapter")]), _vm._v(" details the approach and shows how it fills gaps in other, widely credited explanations for cities’ rise or fall. "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_2__Fleei#page_15"
    }
  }, [_vm._v("Chapter 2")]), _vm._v(" shows how misguided tax policy can erode cities’ inventories of physical capital, repelling or impoverishing those who depend on it, while "), _c('span', {
    attrs: {
      "href": "#/xhtml/08_3__A_1_P#page_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")]), _vm._v(" offers a remedy and provides evidence of its dramatic and favorable effects. "), _c('span', {
    attrs: {
      "href": "#/xhtml/09_4__The_C#page_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")]), _vm._v(" describes how legal and regulatory changes affecting business practices have damaged the productive partnership between labor and capital, and "), _c('span', {
    attrs: {
      "href": "#/xhtml/10_5__A_Bet#page_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")]), _vm._v(" suggests ways to repair this relationship in order to make urban economies more robust. "), _c('span', {
    attrs: {
      "href": "#/xhtml/11_6__Thing#page_83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")]), _vm._v(" addresses complications relating to the creation and maintenance of public property and the conduct of public business, while "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_7__Three#page_100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")]), _vm._v(" provides some rules that can enhance the odds that these things are done efficiently. "), _c('span', {
    attrs: {
      "href": "#/xhtml/13_8__No_Li#page_117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapters 8")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/xhtml/14_9__Contr#page_136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" show how some of our attempts to rescue cities have, by attenuating owners’ rights and squandering social capital in many communities, exacerbated their decline and yielded great inequity. "), _c('span', {
    attrs: {
      "href": "#/xhtml/15_10__Recl#page_155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")]), _vm._v(" describes the consequences of conflicts about property rights in communally owned areas, with special emphasis on street crime and homelessness.")]), _vm._v(" "), _c('p', {
    staticClass: "C86"
  }, [_vm._v("The "), _c('span', {
    attrs: {
      "href": "#/xhtml/16_11__Boom#page_173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("final chapter")]), _vm._v(" provides ten rights-related “commandments” to which policymakers should adhere if they want to maximize the chances that their cities will become or remain healthy. These are, in effect, principles for the successful “reinvention” of any city. And the news is good: "), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_vm._v("though some proposals will surely encounter resistance from certain interest groups, none require doing the impossible (such as immediately ending racism, changing Americans’ tastes for auto travel, or reversing the tide of globalization). Nor do they suggest cities must compete for a special type of employer or class of resident to serve as catalysts for their development, or fundamentally change their nature or economic profile to survive and thrive. They need only attend to residents’ and employers’ deep-seated and legitimate concerns about the security of their property rights, and revisit the myriad ways they might have damaged these rights. If political leaders and private entrepreneurs do so conscientiously, in bankrupt Detroit and elsewhere, they will bestow on all urban residents the chance to prosper and enjoy lives of personal fulfillment and growth.")])]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_c('p', {
    staticClass: "C88"
  }, [_c('em', [_vm._v("Stephen J.K. Walters")])]), _vm._v(" "), _c('p', {
    staticClass: "C60"
  }, [_c('em', [_vm._v("Baltimore, July 2014")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-080f490b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Preface_.vue
// module id = 72
// module chunks = 0